import {
	Disclaimer,
	Reference,
} from '@volkswagen-onehub/disclaimer-manager/dist-es/api';
import {
	CarlineWithOfertas,
	Oferta,
} from '../services/ofertas-service/models/ofertas';

export interface RegisteredDisclaimer {
	readonly text: string;
	readonly ref: Reference | undefined;
	readonly type: 'legal' | 'legal cuota';
	readonly onClick?: () => void;
}

export const getDisclaimers = (
	carlines: CarlineWithOfertas[],
): RegisteredDisclaimer[] => {
	const FOOTER_DISCLAIMER =
		'El responsable del tratamiento de tus datos es VOLKSWAGEN GROUP ESPAÑA DISTRIBUCIÓN, S.A.U., con la finalidad de atender tu solicitud de contacto y tus consultas. Te informamos que tienes derecho a retirar tu consentimiento en cualquier momento, así como a oponerte al tratamiento, limitar el mismo, acceder, rectificar, suprimir los datos y ejercer tu derecho a la portabilidad, mediante petición escrita a atencioncliente@volkswagen.es Puedes consultar con mayor detalle la información adicional sobre protección de datos aquí: https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html';

	const footerDisclaimerText = FOOTER_DISCLAIMER;
	const disclaimers: RegisteredDisclaimer[] = [
		{ ref: '1', text: footerDisclaimerText, type: 'legal' },
	];

	let disclaimerPostion = Number(disclaimers[0].ref);

	carlines.forEach((carline) =>
		carline.ofertas.forEach((oferta) => {
			if (oferta.legal) {
				disclaimerPostion++;
				disclaimers.push({
					ref: `${disclaimerPostion.toString()}.`,
					text: oferta.legal,
					type: 'legal',
				});
			}

			if (oferta.cuotaLegal) {
				disclaimerPostion++;
				disclaimers.push({
					ref: `${disclaimerPostion.toString()}.`,
					text: oferta.cuotaLegal,
					type: 'legal cuota',
				});
			}
		}),
	);

	return disclaimers;
};

export const checkActiveDisclaimer = (
	disclaimers: Disclaimer[],
	legal: string,
): Disclaimer | undefined => {
	return disclaimers.find((disclaimer) => disclaimer.text == legal);
};

export const formatCalculatedDisclaimer = (selectedOferta: Oferta): string =>
	(
		selectedOferta.calculatedFinance.rawResponse?.Response?.Parameters
			?.GlobalDisclaimer ?? ''
	)
		.replace(/^\*/, '')
		.replace(/<u>/g, '**')
		.replace(/<\/u>/g, '**');
